<template>
  <div id="dashboard-analytics">
    <div class="vx-row mt-3">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
        >
          <feather-icon
            icon="AwardIcon"
            class="
              p-6
              mb-8
              bg-primary
              inline-flex
              rounded-full
              text-white
              shadow
            "
            svgClasses="h-8 w-8"
          ></feather-icon>
            <h1 class="mb-6 text-white">{{welcomeMessage}}</h1>
            <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
              {{welcomeText}}
            </p>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
        >
          <!-- <h1 class="mb-6 text-white" @click="$rou">Add an order</h1> -->
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";

export default {
  data() {
    return {
      username: "",
      company: "",
      this_month: 49,
      last_month: 100,
      last_year: 100,
      filled_percentage: 0,
      welcome_message:"",
      welcome_text:"",
      pieChart: {
        series: [49, 100, 100],
        chartOptions: {
          labels: ["This month", "Last month", "Last year"],
          colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },

      themeColors: ["#EA5455", "#FF9F43", "#7367f0", "#FF9F43", "#1E1E1E"],
      radialBarChart: {
        series: [44, 55, 67],
        chartOptions: {
          colors: this.themeColors,
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: "22px",
                },
                value: {
                  fontSize: "16px",
                },
                total: {
                  show: true,
                  label: "Total",
                  formatter: function () {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return 249;
                  },
                },
              },
            },
          },
          labels: ["This month", "Last month", "Last year"],
        },
      },
      salesBar: {
        // series: [{
        //     name: 'Sessions',
        //     data: [75, 125, 225, 175, 125, 75, 25]
        // }],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0,
            },
          },
          chart: {
            type: "bar",
            sparkline: {
              enabled: true,
            },
            toolbar: {
              show: false,
            },
          },
          states: {
            hover: {
              filter: "none",
            },
          },
          colors: [
            "rgba(115,103,240,0.15)",
            "rgba(115,103,240,0.15)",
            "#7367f0",
            "rgba(115,103,240,0.15)",
            "rgba(115,103,240,0.15)",
            "rgba(115,103,240,0.15)",
          ],
          plotOptions: {
            bar: {
              columnWidth: "45%",
              distributed: true,
              endingShape: "rounded", // Deprecated
              // borderRadius: '20px', // Coming Soon
            },
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
      },

      bookmarkedseries: [
        {
          name: "Orders",
          data: [8, 10, 15, 8, 15, 7, 12],
        },
      ],
      Appliedseries: [
        {
          name: "Orders",
          data: [10, 15, 8, 15, 7, 12, 8],
        },
      ],

      dispatchedOrders: [],
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
  },
  computed: {
    welcomeMessage(){
      return this.$store.getters.userNameDomain.split('.').length > 1 ?
        `Welcome ${this.$store.getters.userNameDomain.split('.')[1]}`:`Welcome to ${this.$store.getters.userNameDomain.split('.')[0]}`
    },
    welcomeText(){
        return this.$store.getters.userNameDomain.split('.').length > 1 ?
        `to the ${this.company} ordering portal` :`ordering portal` 
    }
  },
  mounted() {
    this.getUserDetails();
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
